import React from 'react';
import PropTypes from 'prop-types';

import RandomCustomerEmoji from 'components/consumer/RandomCustomerEmoji';
import IconVerified from 'components/icons/iconVerified';

const CustomerNameWithEmoji = ({ className = '', children }) => (
  <div className="text-2xl font-bold items-center text-gray flex mb-3">
    <RandomCustomerEmoji customerName={children} className={className} />
    <h2 className="text-2xl font-bold inline mt-0 mr-0 mb-0 ml-5 relative md:top-[3px]">
      {children}{' '}
    </h2>
    <IconVerified className="h-[18px] ml-1.5 relative top-[-3px] w-[18px] md:top-0 [&_path]:stroke-[#107c8c]" />
  </div>
);

CustomerNameWithEmoji.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default CustomerNameWithEmoji;
